import React, { useEffect, useState } from 'react'
import * as Sentry from "@sentry/react";
import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentAccessToken } from '../../store/slices/auth/authSelectors'
import { refreshSession } from '../../store/slices/auth/authThunks'
import { selectConfigExpressRegistrationPlace } from '../../store/slices/config/configSelectors'
import IconIndicator from '../user-feedback/IconIndicator'
import { Container } from 'rsuite';
import { useInternalUrl } from '../../hooks/usePlaceNavigate';

const RequireAuth = () => {
    const dispatch = useDispatch();
    const place = useSelector(selectConfigExpressRegistrationPlace);
    const token = useSelector(selectCurrentAccessToken)
    const location = useLocation()
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const refresh = async () => {
            try {
                await dispatch(refreshSession());
            } catch (error) {
                Sentry.captureException(error);               
            } finally {
                setLoading(false);
            }
        };

        refresh();
    }, [dispatch]);

    const initUrl = useInternalUrl();

    if (loading) {
        return (
            <Container
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    width: '100vw',
                    margin: 0,
                    padding: 0
                }}
            >
                <IconIndicator />
            </Container>
        )
    }

    return token ? (
        <Outlet />
    ) : (
        <Navigate to={initUrl} state={{ from: location }} replace />
    )
}

export default RequireAuth
